// extracted by mini-css-extract-plugin
module.exports = {"root":"checkbox-description_root__TQzvL"};